import { useNavigate, useSearch } from '@tanstack/react-router';
import { db } from '../db/dexie.js';
import { useT } from '../i18n/index.js';
import { anunciar } from '../lib/hecho.js';
import { anterior, volver } from '../lib/volver.js';
import { Pagina } from '../ui/Pagina.js';
import { TomarPedido } from '../ui/TomarPedido.js';

/**
 * «Nuevo pedido»: an order taken on a screen of its own, opened from the list of orders, which it
 * goes back to once saved, with the order on it (the owner, 2026-10-04). Opened from «Pedido»
 * beside a client, it goes back to the clients, saying whose order was taken: a task ends where it
 * began (`lib/volver.ts`, the owner, 2026-10-08). Its address is under `/clientes/`, inside the
 * clients' section as a client's own page is.
 */
export function NuevoPedido() {
  const t = useT();
  const navigate = useNavigate();
  const { cliente } = useSearch({ from: '/clientes/pedidos/nuevo' });

  async function guardado(pedidoId: string) {
    if (anterior()?.pathname === '/pedidos') {
      // Back to the list as it was, then the new order marked on the pending ones, where it is.
      await volver({ to: '/pedidos' });
      void navigate({ to: '/pedidos', search: { tomado: pedidoId }, replace: true });
      return;
    }
    const pedido = await db.pedidos.get(pedidoId);
    const quien = pedido ? await db.clientes.get(pedido.clienteId) : undefined;
    anunciar(t('pedidos.tomadoPara', { cliente: quien?.nombre ?? t('pos.unCliente') }));
    void volver({ to: '/pedidos', search: { tomado: pedidoId } });
  }

  return (
    <Pagina titulo={t('pedidos.nuevo')} volverA="/pedidos">
      <TomarPedido clienteInicial={cliente} onGuardado={(pedidoId) => void guardado(pedidoId)} />
    </Pagina>
  );
}
